import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { AuthService } from '../../services';
import {
  types as actions,
  checkedSSOAction,
  loginErrorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.CHECK_SSO),
    switchMap(action => 
      AuthService.checkSSO(action.email, action.host).pipe(
        map(data => checkedSSOAction(data.response)),
        catchError(error => of(loginErrorAction(error)))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/auth/checkSSO.js